import React from 'react';
import Icon from '../../components/common/Icon';
import { trackDistributorInteraction } from '../analytics';
import { text } from '../data';
import DOMPurify from 'dompurify';

export interface MyDistributorsCarouselItemProps {
    title: string;
    category?: string;
    coordinates?: string;
    address?: string;
    phone?: string;
    email?: string;
    websiteUrl?: string;
    distributorCustomerNumber?: string;
    distributorId?: string;
    markerId?: string;
    isActive?: boolean;
    deleteAction?: (event) => void;
}

const MyDistributorsCarouselItem: React.FC<MyDistributorsCarouselItemProps> = ({ title, category, coordinates, address, phone, websiteUrl, distributorId, markerId, isActive, deleteAction }) => {
	const distributorUrl = window?._timken?.distributorUrl as string ?? 'https://locations.timken.com/distributor-locator/';

	const buildDirectionsUrl = () => {
		if (! coordinates) {
			return '';
		}
		return `${ distributorUrl }?address=${ address }&marker_id=${ markerId }`;
	};

	const triggerOtherAnalytics = (targetText = '') => {
		triggerDistributorAnalytics(address, 'other_click', targetText, websiteUrl);
	};

	const triggerVisitWebsiteAnalytics = (targetText = '') => {
		triggerDistributorAnalytics(address, 'visit_website_click', targetText, websiteUrl);
	};

	const triggerClickToCallAnalytics = (targetText = '') => {
		triggerDistributorAnalytics(address, 'click_to_call', targetText, phone ? `tel:${ phone }` : '');
	};

	const triggerDirectionsAnalytics = (targetTtext: string) => {
		triggerDistributorAnalytics(address, 'get_directions_click', targetTtext, buildDirectionsUrl());
	};
	// visit_website_click
	const buildTitle = () => {
		if (! coordinates) {
			return (
				<div className='t-my-distributors-carousel__item__title'>{title}</div>
			);
		}
		return (
			<a href={buildDirectionsUrl()} onClick={() => {
				triggerOtherAnalytics(title);
			}} target="_blank" className='t-my-distributors-carousel__item__title' rel="noreferrer">{title}</a>
		);
	};

	const triggerDistributorAnalytics = (address, interaction_type, link_text, link_url) => {
		trackDistributorInteraction(address, title, interaction_type, link_text, link_url, category);
	};

	return (
		<div className={`t-my-distributors-carousel__item ${ isActive ? '' : 't-my-distributors-carousel__item--disabled' }`}>
			<div className="t-my-distributors-carousel__item__info">
				{title && (
					buildTitle()
				)}
				<div className='t-my-distributors-carousel__item__category'>{category}</div>
				{address && (
					<div className='t-my-distributors-carousel__item__address' dangerouslySetInnerHTML={ { __html: DOMPurify.sanitize(address) } } />
				)}
				{phone && (
					<div className={"t-my-distributors-carousel__item__phone"}>
						{text.phone}: <a href={`tel:${phone}`} className='link-underline'
										 onClick={() => {
											 triggerClickToCallAnalytics(`${text.phone}: ${phone}`);
										 }}>{phone}</a>
					</div>
				)}
			</div>
			<ul className="t-my-distributors-carousel__item__links">
				{websiteUrl && (
					<li>
						<Icon icon="globe" />
						<a href={websiteUrl} onClick={() => {
							triggerVisitWebsiteAnalytics(text.visitWebsite);
						}} target="_blank" className="btn--tertiary" rel="noreferrer">{text.visitWebsite}</a>
					</li>
				)}
				{coordinates && (
					<li>
						<Icon icon="map-location" />
						<a href={buildDirectionsUrl()} onClick={() => {
							triggerDirectionsAnalytics(text.getDirections);
						}} target="_blank" className="btn--tertiary" rel="noreferrer">{text.getDirections}</a>
					</li>
				)}
				<li>
					<Icon icon="trash-outline" />
					<a href="#" onClick={deleteAction} className="btn--tertiary btn--delete">{text.remove}</a>
				</li>
			</ul>
		</div>
	);
};

export default MyDistributorsCarouselItem;
